import { render, staticRenderFns } from "./CompensatoryOvertimeDetail.vue?vue&type=template&id=2ecc3a54&"
import script from "./CompensatoryOvertimeDetail.vue?vue&type=script&lang=js&"
export * from "./CompensatoryOvertimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports